<section class="content">
  <div class="card" style="padding:25px" *ngIf="!show_add_product_page">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
      <div class="col" style="text-align: right;">
        <button mat-button (click)="enableProductAddPage('Register')"
          style="background: #64073d;border-radius: 10px; font-size: 23px; color: white;">Add Product</button>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!is_data_available">
    <div class="col">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
      </mat-progress-spinner>
    </div>
  </div>
  <div class="row" *ngIf="!show_add_product_page && is_data_available">
    <div class="col">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let product_group of by_product_group_list" style="margin-bottom: 1%;">
          <mat-expansion-panel-header style="padding: 30px;">
            <mat-panel-title>
              {{product_group['name']}} &nbsp; &nbsp; <i> Total Product :
                <span *ngIf="by_product_dict.hasOwnProperty(product_group['id'])">
                  {{by_product_dict[product_group['id']].length}}
                </span>
                <span *ngIf="!by_product_dict.hasOwnProperty(product_group['id'])">
                  0
                </span>
              </i>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <table class="table table-bordered table-hovered">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Product Name</th>
                <th>Product Code</th>
                <th>Quantity</th>
                <th>IGST</th>
                <th>SGST</th>
                <th>CGST</th>
                <th>Mrp</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody *ngFor="let product of by_product_dict[product_group['id']]; let product_index=index">
              <tr>
                <td>{{product_index + 1}}</td>
                <td>{{product['name']}}</td>
                <td>{{product['product_code']}}</td>
                <td>{{product['quantity']}} {{product['unit_name']}}</td>
                <td>{{product['igst_amount']}}</td>
                <td>{{product['sgst_amount']}}</td>
                <td>{{product['cgst_amount']}}</td>
                <td>{{product['mrp']}}</td>
                <td><i class="material-icons" style="cursor: pointer;"
                    (click)="enableProductAddPage('Update',product)">edit</i></td>
              </tr>
            </tbody>
          </table>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="row" *ngIf="show_add_product_page">
    <div class="col-sm-2 col-lg-2" (click)="enableProductAddPage('')">
      <i class="material-icons" style="margin-left: 2%; font-size:46px;cursor: pointer;">arrow_back</i>
    </div>
    <div class="col-sm-6 col-lg-6">
      <p class="text-center" style="font-size: 30px;">{{page_header}}</p>
    </div>
    <div class="col-sm-4 col-lg-4"></div>
  </div>
  <mat-card class="mat-elevation-z8" *ngIf="show_add_product_page">
    <form [formGroup]="product_register_form">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Product Group<i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <select class="form-control dropdown_box" formControlName='group_id' [attr.disabled]="checkDisable()">
              <option *ngFor="let product_group of by_product_group_list" [value]="product_group['id']">
                {{product_group['name']}} </option>
            </select>
          </div>
        </div>

        <div class="col">
          <div class="form-group">
            <!-- Mini Floating Action Button (FAB) with an Icon -->
            <button mat-mini-fab color="primary" (click)="openDialog()" style="margin-top: 5%;">
              <mat-icon>add</mat-icon>
            </button>

          </div>

        </div>


        <div class="col">
          <div class="form-group">
            <label>Name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='name' [attr.disabled]="checkDisable()">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Product Code <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='product_code'>
          </div>
        </div>
        <!-- attr.disabled]="action == 'update' ? 'attr.disabled' : null" -->
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Base Price <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              class="form-control code_box" formControlName='base_price'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Mrp <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              class="form-control code_box" formControlName='mrp'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Display Ordinal <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='display_ordinal'>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>CGST Percentage</label>
            <input type="number" class="form-control code_box" formControlName='cgst_percent'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>SGST Percentage</label>
            <input type="number" class="form-control code_box" formControlName='sgst_percent'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>IGST Percentage</label>
            <input type="text" class="form-control code_box" formControlName='igst_percent' [attr.disabled]="true">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>CGST Amount <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" class="form-control code_box" formControlName='cgst_amount'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>SGST Amount <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" class="form-control code_box" formControlName='sgst_amount'>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>IGST Amount <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="text" class="form-control code_box" formControlName='igst_amount' [attr.disabled]="true">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Quantity <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <input type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              class="form-control code_box" formControlName='quantity' [attr.disabled]="checkDisable()">
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Unit <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
            <select class="form-control dropdown_box" formControlName='unit_id' [attr.disabled]="checkDisable()">
              <option *ngFor="let unit of unit_list" [value]="unit['id']">{{unit['name']}} </option>
            </select>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <label>Description</label>
            <input type="text" class="form-control code_box" formControlName='description'>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col" style="text-align: center;">
          <button mat-raised-button color="primary" (click)="registerOrUpdateProduct()"
            [disabled]="!product_register_form.valid" style="text-transform: capitalize">{{action}}</button>
        </div>


      </div>
    </form>
  </mat-card>
</section>